<ng-template [ngIf]="contractDetailsForm" [ngIfElse]="init">
  <div class="bg-white p-xl-5 p-2">
    <div class="border-bottom border-gray">
      <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h3 class="text-end text-secondary pb-2" *ngIf="isReadingMode">Contrat du {{ contract.beginDate | date }} au {{ contract.endDate | date }}</h3>
      <h3 class="text-end text-secondary pb-2" *ngIf="!isReadingMode">Création d'un contrat</h3>
    </div>
    <form [formGroup]="contractDetailsForm" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="row">
          <div class="mb-3 text-secondary col-12">
            <small class="form-text text-secondary">Les champs marqués d'un * sont obligatoires. </small>
          </div>

          <!-- Types -->
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">Type de contrat</label>
            <select
              class="form-select"
              formControlName="contractType"
              [class.is-invalid]="submitted && contractDetailsForm.controls.contractType.invalid"
              (ngModelChange)="setDates($event)"
            >
              <option *ngIf="!contractDetailsForm.controls?.contractType?.value" [ngValue]="" selected hidden></option>
              <option
                *ngFor="let contractType of contractTypes | keyvalue: StringUtils.stringAscOrder"
                [ngValue]="contractType.value"
                [hidden]="contractType.value === 'Reprise IODAS'"
              >
                {{ contractType.value }}
              </option>
            </select>
            <small *ngIf="submitted && contractDetailsForm.controls?.contractType?.errors?.required" class="form-text text-danger"
              >Le type de contrat est requis.</small
            >
          </div>
          <div class="mb-3 col-12 col-lg-6"></div>

          <!-- Dates -->
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">Date de début</label>
            <app-datepicker
              id="fieldBeginDate"
              formControlName="beginDate"
              [invalid]="submitted && (contractDetailsForm.errors?.datesOrder || contractDetailsForm.controls?.beginDate?.invalid)"
            ></app-datepicker>
            <small *ngIf="submitted && contractDetailsForm.errors?.datesOrder" class="form-text text-danger"
              >La date de début est incohérente avec la date de fin.</small
            >
            <small
              *ngIf="
                submitted && !contractDetailsForm.controls?.beginDate?.errors?.required && contractDetailsForm.controls?.beginDate?.errors?.dateFormat
              "
              class="form-text text-danger"
              >La date de début est invalide.</small
            >
            <small *ngIf="submitted && contractDetailsForm.controls?.beginDate?.errors?.required" class="form-text text-danger"
              >La date de début est requise.</small
            >
          </div>
          <div class="mb-3 col-12 col-lg-6">
            <label class="text-secondary required">Date de fin</label>
            <app-datepicker
              id="fieldEndDate"
              formControlName="endDate"
              [invalid]="submitted && (contractDetailsForm.errors?.datesOrder || contractDetailsForm.controls?.endDate?.invalid)"
            ></app-datepicker>
            <small *ngIf="submitted && contractDetailsForm.errors?.datesOrder" class="form-text text-danger"
              >La date de fin est incohérente avec la date de début.</small
            >
            <small
              *ngIf="
                submitted && !contractDetailsForm.controls?.endDate?.errors?.required && contractDetailsForm.controls?.endDate?.errors?.dateFormat
              "
              class="form-text text-danger"
              >La date de fin est invalide.</small
            >
            <small *ngIf="submitted && contractDetailsForm.controls?.endDate?.errors?.required" class="form-text text-danger"
              >La date de fin est requise.</small
            >
          </div>

          <!-- Objectif -->
          <div class="mb-3 col-12">
            <label class="text-secondary required">Objectif principal</label>
            <textarea
              formControlName="mainPurpose"
              class="form-control"
              [class.is-invalid]="submitted && contractDetailsForm.controls.mainPurpose.invalid"
            ></textarea>
            <small *ngIf="submitted && contractDetailsForm.controls?.mainPurpose?.errors?.required" class="form-text text-danger"
              >L'objectif principal est requis.</small
            >
          </div>

          <!-- Projet et Actions -->
          <div class="mb-3 col-12">
            <label class="text-secondary">Projet</label>
            <textarea formControlName="project" class="form-control"></textarea>
          </div>
          <div class="mb-3 col-12">
            <label class="text-secondary">Actions à réaliser</label>
            <textarea formControlName="actionsToPerform" class="form-control"></textarea>
          </div>
          <ng-container *ngIf="!isWorkflowedContract">
            <!-- Etat et date d'état -->
            <div class="mb-3 col-12 col-lg-6">
              <label class="text-secondary required">État</label>
              <select class="form-select" formControlName="status" [class.is-invalid]="submitted && contractDetailsForm.controls.status.invalid">
                <option *ngIf="!contractDetailsForm.value.status" [ngValue]="" selected hidden></option>
                <option *ngFor="let status of statusMap | keyvalue: StringUtils.stringAscOrder" [ngValue]="status.value">
                  {{ status.value }}
                </option>
              </select>
              <small *ngIf="submitted && contractDetailsForm.controls?.status?.errors?.required" class="form-text text-danger"
                >L'état est requis.</small
              >
            </div>
            <div class="mb-3 col-12 col-lg-6">
              <label class="text-secondary">Date d'état</label>
              <app-datepicker id="fieldBeginDate" formControlName="statusDate"></app-datepicker>
            </div>

            <!-- Atteinte -->
            <div class="mb-3 col-12 col-lg-6">
              <label class="text-secondary">Atteinte</label>
              <select class="form-select" formControlName="achievement">
                <option *ngIf="!contractDetailsForm?.controls?.achievement?.value" [ngValue]="" selected hidden></option>
                <option *ngFor="let achievement of achievements | keyvalue: StringUtils.stringAscOrder" [ngValue]="achievement.key">
                  {{ achievement.value }}
                </option>
              </select>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Boutons actions -->
      <div class="row px-3 d-flex justify-content-end" *ngIf="isWorkflowedContract">
        <div
          class="d-grid col-3 col-md-6 col-lg-3 mb-1"
          *hasPermission="'CAN_DELETE'; subject: contract; context: workflowedContractPermissionContext"
        >
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="delete()" *ngIf="!isCreation">
            <fa-icon icon="trash"></fa-icon>
            <span class="ms-3 d-none d-md-block">Supprimer</span>
          </button>
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
            <fa-icon icon="ban"></fa-icon>
            <span class="ms-3 d-none d-md-block">Annuler</span>
          </button>
        </div>

        <!-- ********************************************************************************************* -->
        <!-- * WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED W * -->
        <!-- * WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED WORKFLOWED W * -->
        <!-- ********************************************************************************************* -->

        <div
          class="col-3 col-md-6 col-lg-3 mb-1"
          *hasPermission="
            [
              'CAN_EDIT',
              workflowedContractPermissionContext + '_CAN_BENEF_SIGN',
              workflowedContractPermissionContext + '_CAN_ROLLBACK',
              workflowedContractPermissionContext + '_CAN_VALIDATE',
              workflowedContractPermissionContext + '_CAN_SIGN',
              workflowedContractPermissionContext + '_CAN_REJECT',
              workflowedContractPermissionContext + '_CAN_CLOSE',
              workflowedContractPermissionContext + '_CAN_REOPEN'
            ];
            subject: contract;
            context: workflowedContractPermissionContext
          "
        >
          <div ngbDropdown class="d-inline-block">
            <button class="btn btn-primary w-auto" id="dropdownPrint" type="button" ngbDropdownToggle>
              <fa-icon icon="directions"></fa-icon>
              <span class="mx-3">Actions</span>
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownPrint">
              <button
                class="dropdown-item"
                type="submit"
                *hasPermission="'CAN_EDIT'; subject: contract; context: workflowedContractPermissionContext"
              >
                Sauvegarder
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedBeneficiary)"
                *hasPermission="
                  workflowedContractPermissionContext + '_CAN_BENEF_SIGN';
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Signer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Creation)"
                *hasPermission="
                  workflowedContractPermissionContext + '_CAN_ROLLBACK';
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Retour en Création
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.ValidatedMetro)"
                *hasPermission="
                  workflowedContractPermissionContext + '_CAN_VALIDATE';
                  subject: contract;
                  context: workflowedContractPermissionContext
                "
              >
                Valider
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedMetro)"
                *hasPermission="workflowedContractPermissionContext + '_CAN_SIGN'; subject: contract; context: workflowedContractPermissionContext"
              >
                Signer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Unvalidated)"
                *hasPermission="workflowedContractPermissionContext + '_CAN_REJECT'; subject: contract; context: workflowedContractPermissionContext"
              >
                Rejeter
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.Done)"
                *hasPermission="workflowedContractPermissionContext + '_CAN_CLOSE'; subject: contract; context: workflowedContractPermissionContext"
              >
                Terminer
              </button>
              <button
                class="dropdown-item"
                type="button"
                (click)="workflowAction(traceabilityStatus.SignedMetro)"
                *hasPermission="workflowedContractPermissionContext + '_CAN_REOPEN'; subject: contract; context: workflowedContractPermissionContext"
              >
                Rouvrir le contrat
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row px-3 d-flex justify-content-end" *ngIf="!isWorkflowedContract">
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1" *appOnlyGroups="['ADMIN']">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="delete()" *ngIf="!isCreation">
            <fa-icon icon="trash"></fa-icon>
            <span class="ms-3 d-none d-md-block">Supprimer</span>
          </button>
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
            <fa-icon icon="ban"></fa-icon>
            <span class="ms-3 d-none d-md-block">Annuler</span>
          </button>
        </div>
        <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button
            *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+']"
            class="btn btn-primary d-flex justify-content-center"
            type="submit"
            [disabled]="!contractTypeSelected"
          >
            <fa-icon icon="save"></fa-icon>
            <span class="ms-3 d-none d-md-block">Sauvegarder</span>
          </button>
        </div>
      </div>
    </form>
    <div class="card border-0 card-border-radius-0 mt-4" *ngIf="traceability?.length !== 0 && isWorkflowedContract">
      <div class="card-body p-0">
        <div class="table-responsive">
          <div ngbAccordion [closeOthers]="false">
            <div ngbAccordionItem>
              <h2 ngbAccordionHeader>
                <button ngbAccordionButton class="accordion-button text-secondary">
                  <span id="traceabilityTitle">Traçabilité</span>
                </button>
              </h2>
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <div class="col px-0 pt-2">
                      <table class="table table-striped table-hover table-nowrap" aria-describedby="traceabilityTitle">
                        <thead class="text-secondary bg-light">
                          <tr>
                            <th scope="col" class="text-center">Etat</th>
                            <th scope="col" class="text-center">Date de l'état</th>
                            <th scope="col" class="text-center">Réalisé par</th>
                            <th scope="col" class="text-center">Commentaire</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let trace of traceability">
                            <td class="text-center">
                              {{ trace.status }}
                            </td>
                            <td class="text-center">{{ trace.statusDate | date }}</td>
                            <td class="text-center">
                              {{ trace.performedBy }}
                            </td>
                            <td>{{ trace.comment }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #init>
  <div class="bg-white p-xl-5 p-2"></div>
</ng-template>
